import { render, staticRenderFns } from "./EcardManagement.vue?vue&type=template&id=4d3139b5&scoped=true"
import script from "./EcardManagement.vue?vue&type=script&lang=js"
export * from "./EcardManagement.vue?vue&type=script&lang=js"
import style0 from "./EcardManagement.vue?vue&type=style&index=0&id=4d3139b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3139b5",
  null
  
)

export default component.exports